export default "__VITE_ASSET__BjwwbJzD__"